import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: Date;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUpdateUserDto = {
  readonly bio?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly isAdmin: Scalars['Boolean'];
  readonly lastName: Scalars['String'];
  readonly username: Scalars['String'];
};

export type AnonymousChangePasswordDto = {
  readonly newPassword: Scalars['String'];
  readonly token?: Maybe<Scalars['String']>;
};

export type Auth = {
  readonly __typename?: 'Auth';
  readonly accessToken: Scalars['String'];
  /** JWT refresh token */
  readonly refreshToken: Scalars['String'];
  readonly user?: Maybe<User>;
};

export type Ban = {
  readonly __typename?: 'Ban';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly motive: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type BankInfo = {
  readonly __typename?: 'BankInfo';
  readonly bankName: Scalars['String'];
  readonly last4: Scalars['String'];
};

export type Book = {
  readonly __typename?: 'Book';
  readonly author: User;
  readonly authorId: Scalars['ID'];
  readonly bookId?: Maybe<Scalars['ID']>;
  readonly cover?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly description?: Maybe<Scalars['String']>;
  readonly forkAllowed: Scalars['Boolean'];
  readonly forks: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly isFork: Scalars['Boolean'];
  readonly isPremium: Scalars['Boolean'];
  readonly language: Language;
  readonly mature: Scalars['Boolean'];
  readonly metadata: BookMetadata;
  readonly publishedAt?: Maybe<Scalars['Date']>;
  readonly status: BookStatus;
  readonly title: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly withHelp: Scalars['Boolean'];
};

export type BookCoAuthor = {
  readonly __typename?: 'BookCoAuthor';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type BookCoAuthorEdge = {
  readonly __typename?: 'BookCoAuthorEdge';
  readonly cursor: Scalars['String'];
  readonly node: BookCoAuthor;
};

export type BookCoAuthorPagination = {
  readonly __typename?: 'BookCoAuthorPagination';
  readonly edges?: Maybe<ReadonlyArray<BookCoAuthorEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type BookComment = {
  readonly __typename?: 'BookComment';
  readonly author: User;
  readonly authorId: Scalars['ID'];
  readonly bookId: Scalars['ID'];
  readonly content: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type BookCommentEdge = {
  readonly __typename?: 'BookCommentEdge';
  readonly cursor: Scalars['String'];
  readonly node: BookComment;
};

export type BookCommentPagination = {
  readonly __typename?: 'BookCommentPagination';
  readonly edges?: Maybe<ReadonlyArray<BookCommentEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type BookEdge = {
  readonly __typename?: 'BookEdge';
  readonly cursor: Scalars['String'];
  readonly node: Book;
};

export type BookLike = {
  readonly __typename?: 'BookLike';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type BookMetadata = {
  readonly __typename?: 'BookMetadata';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  readonly category: Category;
  readonly categoryId: Scalars['String'];
  readonly coAuthors?: Maybe<ReadonlyArray<BookCoAuthor>>;
  readonly comments?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly customTags?: Maybe<ReadonlyArray<CustomTag>>;
  readonly fragments?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly likes: Scalars['Int'];
  readonly moderators?: Maybe<ReadonlyArray<BookModerator>>;
  readonly reads: Scalars['Int'];
  readonly tags: ReadonlyArray<Tag>;
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type BookModerator = {
  readonly __typename?: 'BookModerator';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type BookModeratorEdge = {
  readonly __typename?: 'BookModeratorEdge';
  readonly cursor: Scalars['String'];
  readonly node: BookModerator;
};

export type BookModeratorPagination = {
  readonly __typename?: 'BookModeratorPagination';
  readonly edges?: Maybe<ReadonlyArray<BookModeratorEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type BookPagination = {
  readonly __typename?: 'BookPagination';
  readonly edges?: Maybe<ReadonlyArray<BookEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type BookRead = {
  readonly __typename?: 'BookRead';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

/** Book status */
export enum BookStatus {
  DRAFT = 'DRAFT',
  EDIT = 'EDIT',
  PUBLISHED = 'PUBLISHED'
}

/** Book status that are visible */
export enum BookVisibleStatus {
  EDIT = 'EDIT',
  PUBLISHED = 'PUBLISHED'
}

export type Category = {
  readonly __typename?: 'Category';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type CategoryEdge = {
  readonly __typename?: 'CategoryEdge';
  readonly cursor: Scalars['String'];
  readonly node: Category;
};

export type CategoryPagination = {
  readonly __typename?: 'CategoryPagination';
  readonly edges?: Maybe<ReadonlyArray<CategoryEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type ChangePasswordDto = {
  readonly newPassword: Scalars['String'];
  readonly oldPassword: Scalars['String'];
};

export type Chat = {
  readonly __typename?: 'Chat';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly messages: ReadonlyArray<ChatMessage>;
  readonly participants: ReadonlyArray<User>;
  readonly recipient: User;
  readonly recipientId: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type ChatEdge = {
  readonly __typename?: 'ChatEdge';
  readonly cursor: Scalars['String'];
  readonly node: Chat;
};

export type ChatMessage = {
  readonly __typename?: 'ChatMessage';
  readonly author: User;
  readonly authorId: Scalars['String'];
  readonly chat: Chat;
  readonly chatId: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly message: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type ChatMessageEdge = {
  readonly __typename?: 'ChatMessageEdge';
  readonly cursor: Scalars['String'];
  readonly node: ChatMessage;
};

export type ChatMessagePagination = {
  readonly __typename?: 'ChatMessagePagination';
  readonly edges?: Maybe<ReadonlyArray<ChatMessageEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type ChatPagination = {
  readonly __typename?: 'ChatPagination';
  readonly edges?: Maybe<ReadonlyArray<ChatEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type CreateBanDto = {
  readonly motive: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type CreateBookCoAuthorDto = {
  readonly bookId: Scalars['ID'];
  readonly userId: Scalars['ID'];
};

export type CreateBookCommentDto = {
  readonly bookId: Scalars['ID'];
  readonly content: Scalars['String'];
};

export type CreateBookDto = {
  readonly category: Scalars['ID'];
  readonly cover?: Maybe<Scalars['Upload']>;
  readonly customTags?: Maybe<ReadonlyArray<Scalars['ID']>>;
  readonly description?: Maybe<Scalars['String']>;
  readonly forkAllowed: Scalars['Boolean'];
  readonly isPremium: Scalars['Boolean'];
  readonly language: Language;
  readonly mature: Scalars['Boolean'];
  readonly status: BookStatus;
  readonly tags: ReadonlyArray<Scalars['ID']>;
  readonly title: Scalars['String'];
  readonly withHelp: Scalars['Boolean'];
};

export type CreateBookForkDto = {
  readonly bookId: Scalars['ID'];
  readonly fragmentId: Scalars['ID'];
};

export type CreateBookModeratorDto = {
  readonly bookId: Scalars['ID'];
  readonly userId: Scalars['ID'];
};

export type CreateChatDto = {
  readonly participantId: Scalars['ID'];
};

export type CreateChatMessageDto = {
  readonly chatId: Scalars['ID'];
  readonly message: Scalars['String'];
};

export type CreateFeedbackDto = {
  readonly content: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
};

export type CreateFragmentCommentDto = {
  readonly content: Scalars['String'];
  readonly fragmentId: Scalars['ID'];
};

export type CreateFragmentDto = {
  readonly bookId: Scalars['ID'];
  readonly content: Scalars['JSONObject'];
  readonly status: FragmentStatus;
};

export type CreateReadingListDto = {
  readonly isPublic: Scalars['Boolean'];
  readonly title: Scalars['String'];
};

export type CreateReportDto = {
  readonly motive: Scalars['String'];
  readonly origin: ReportOrigin;
  readonly originId: Scalars['ID'];
};

export type CreateStripeBankAccountDto = {
  readonly token: Scalars['String'];
};

export type CreateStripeConnectedAccountDto = {
  readonly country: Scalars['String'];
  readonly token: Scalars['String'];
};

export type CreateStripeSubscriptionDto = {
  readonly period: Scalars['Int'];
  readonly token: Scalars['String'];
};

export type CustomTag = {
  readonly __typename?: 'CustomTag';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type EmailVerification = {
  readonly __typename?: 'EmailVerification';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type EntityOrder = {
  readonly direction: OrderDirection;
  readonly field: OrderField;
};

export type FacebookLoginDto = {
  readonly access_token: Scalars['String'];
};

export type Feedback = {
  readonly __typename?: 'Feedback';
  readonly content: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly email?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user?: Maybe<User>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type FeedbackEdge = {
  readonly __typename?: 'FeedbackEdge';
  readonly cursor: Scalars['String'];
  readonly node: Feedback;
};

export type FeedbackPagination = {
  readonly __typename?: 'FeedbackPagination';
  readonly edges?: Maybe<ReadonlyArray<FeedbackEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type Fragment = {
  readonly __typename?: 'Fragment';
  readonly author?: Maybe<User>;
  readonly authorId: Scalars['String'];
  readonly book?: Maybe<Book>;
  readonly bookId: Scalars['String'];
  readonly content: Scalars['JSONObject'];
  readonly contribution?: Maybe<FragmentContribution>;
  readonly contributionId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly metadata: FragmentMetadata;
  readonly readOnly: Scalars['Boolean'];
  readonly retouch?: Maybe<Scalars['JSONObject']>;
  readonly status: FragmentStatus;
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type FragmentAlternative = {
  readonly __typename?: 'FragmentAlternative';
  readonly book: BookMetadata;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragment: Fragment;
  readonly fragmentId: Scalars['String'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type FragmentAlternativeEdge = {
  readonly __typename?: 'FragmentAlternativeEdge';
  readonly cursor: Scalars['String'];
  readonly node: FragmentAlternative;
};

export type FragmentAlternativePagination = {
  readonly __typename?: 'FragmentAlternativePagination';
  readonly edges?: Maybe<ReadonlyArray<FragmentAlternativeEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type FragmentComment = {
  readonly __typename?: 'FragmentComment';
  readonly author: User;
  readonly authorId: Scalars['ID'];
  readonly content: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragmentId: Scalars['ID'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type FragmentCommentEdge = {
  readonly __typename?: 'FragmentCommentEdge';
  readonly cursor: Scalars['String'];
  readonly node: FragmentComment;
};

export type FragmentCommentPagination = {
  readonly __typename?: 'FragmentCommentPagination';
  readonly edges?: Maybe<ReadonlyArray<FragmentCommentEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type FragmentContribution = {
  readonly __typename?: 'FragmentContribution';
  readonly book: Book;
  readonly bookId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragments: ReadonlyArray<Fragment>;
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type FragmentContributionEdge = {
  readonly __typename?: 'FragmentContributionEdge';
  readonly cursor: Scalars['String'];
  readonly node: FragmentContribution;
};

export type FragmentContributionPagination = {
  readonly __typename?: 'FragmentContributionPagination';
  readonly edges?: Maybe<ReadonlyArray<FragmentContributionEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type FragmentEdge = {
  readonly __typename?: 'FragmentEdge';
  readonly cursor: Scalars['String'];
  readonly node: Fragment;
};

export type FragmentLike = {
  readonly __typename?: 'FragmentLike';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragment: Fragment;
  readonly fragmentId: Scalars['String'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type FragmentMetadata = {
  readonly __typename?: 'FragmentMetadata';
  readonly comments: Scalars['Int'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragment: Fragment;
  readonly fragmentId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly likes: Scalars['Int'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type FragmentPagination = {
  readonly __typename?: 'FragmentPagination';
  readonly edges?: Maybe<ReadonlyArray<FragmentEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** Fragment status */
export enum FragmentStatus {
  APPROVAL = 'APPROVAL',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

/** Fragment status that are visible */
export enum FragmentVisibleStatus {
  APPROVAL = 'APPROVAL',
  PUBLISHED = 'PUBLISHED'
}

/** Available languages */
export enum Language {
  EN = 'EN',
  RO = 'RO'
}

/** Action that can be use to add/remove item from an array */
export enum ListActions {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type LoginDto = {
  readonly email: Scalars['String'];
  readonly password: Scalars['String'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly adminLogin: Auth;
  readonly adminLogout: Scalars['Boolean'];
  readonly adminRemoveBook: Book;
  readonly adminUpdateUser: User;
  readonly anonymousChangePassword: Auth;
  readonly cancelStripeSubscription?: Maybe<Scalars['Boolean']>;
  readonly changePassword: User;
  readonly createBan: Ban;
  readonly createBook: Book;
  readonly createBookCoAuthor?: Maybe<BookCoAuthor>;
  readonly createBookComment: BookComment;
  readonly createBookLike?: Maybe<BookLike>;
  readonly createBookModerator?: Maybe<BookModerator>;
  readonly createBookRead?: Maybe<BookRead>;
  readonly createChat: Chat;
  readonly createChatMessage: ChatMessage;
  readonly createFeedback: Feedback;
  readonly createFork: Book;
  readonly createFragment: Fragment;
  readonly createFragmentComment: FragmentComment;
  readonly createFragmentLike?: Maybe<FragmentLike>;
  readonly createReadingList: ReadingList;
  readonly createReport: Report;
  readonly createStripeBankAccount?: Maybe<StripeConnected>;
  readonly createStripeConnectedAccount?: Maybe<StripeConnected>;
  readonly createStripeSubscription?: Maybe<PremiumUser>;
  readonly login: Auth;
  readonly loginFacebook: Auth;
  readonly payout?: Maybe<Scalars['Boolean']>;
  readonly publishBook: Book;
  readonly readNotifications?: Maybe<Scalars['Int']>;
  readonly refreshToken: Token;
  readonly removeBan: Scalars['Boolean'];
  readonly removeBook: Book;
  readonly removeBookComment: BookComment;
  readonly removeBookLike?: Maybe<BookLike>;
  readonly removeBookModerator: BookModerator;
  readonly removeFragment: Fragment;
  readonly removeFragmentComment: FragmentComment;
  readonly removeFragmentLike?: Maybe<FragmentLike>;
  readonly removeNotification: Notification;
  readonly removeReadingList: ReadingList;
  readonly removeUser: User;
  readonly resetPassword?: Maybe<EmailVerification>;
  readonly restartStripeSubscription?: Maybe<Scalars['Boolean']>;
  readonly signup: Auth;
  readonly startVerification?: Maybe<StripeConnected>;
  readonly updateAvatar?: Maybe<User>;
  readonly updateBook: Book;
  readonly updateFragment: Fragment;
  readonly updatePaymentMethod?: Maybe<Scalars['Boolean']>;
  readonly updateReadingList: ReadingList;
  readonly updateStripeSubscription?: Maybe<Scalars['Boolean']>;
  readonly updateUser: User;
  readonly verifyAccount?: Maybe<StripeConnected>;
};


export type MutationAdminLoginArgs = {
  loginDto: LoginDto;
};


export type MutationAdminRemoveBookArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationAdminUpdateUserArgs = {
  adminUpdateUserDto: AdminUpdateUserDto;
  id?: Maybe<Scalars['ID']>;
};


export type MutationAnonymousChangePasswordArgs = {
  anonymousChangePasswordDto: AnonymousChangePasswordDto;
};


export type MutationChangePasswordArgs = {
  changePasswordDto: ChangePasswordDto;
};


export type MutationCreateBanArgs = {
  createBanDto: CreateBanDto;
};


export type MutationCreateBookArgs = {
  createBookDto: CreateBookDto;
};


export type MutationCreateBookCoAuthorArgs = {
  createBookCoAuthorDto: CreateBookCoAuthorDto;
};


export type MutationCreateBookCommentArgs = {
  createBookCommentDto: CreateBookCommentDto;
};


export type MutationCreateBookLikeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationCreateBookModeratorArgs = {
  createBookModeratorDto: CreateBookModeratorDto;
};


export type MutationCreateBookReadArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationCreateChatArgs = {
  createChatDto: CreateChatDto;
};


export type MutationCreateChatMessageArgs = {
  createChatMessageDto: CreateChatMessageDto;
};


export type MutationCreateFeedbackArgs = {
  createFeedbackDto: CreateFeedbackDto;
};


export type MutationCreateForkArgs = {
  createBookForkDto: CreateBookForkDto;
};


export type MutationCreateFragmentArgs = {
  createFragmentDto: CreateFragmentDto;
};


export type MutationCreateFragmentCommentArgs = {
  createFragmentCommentDto: CreateFragmentCommentDto;
};


export type MutationCreateFragmentLikeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationCreateReadingListArgs = {
  createReadingListDto: CreateReadingListDto;
};


export type MutationCreateReportArgs = {
  createReportDto: CreateReportDto;
};


export type MutationCreateStripeBankAccountArgs = {
  createStripeBankAccountDto: CreateStripeBankAccountDto;
};


export type MutationCreateStripeConnectedAccountArgs = {
  createStripeConnectedAccountDto: CreateStripeConnectedAccountDto;
};


export type MutationCreateStripeSubscriptionArgs = {
  createStripeSubscriptionDto: CreateStripeSubscriptionDto;
};


export type MutationLoginArgs = {
  loginDto: LoginDto;
};


export type MutationLoginFacebookArgs = {
  facebookLoginDto: FacebookLoginDto;
};


export type MutationPayoutArgs = {
  payoutDto: PayoutDto;
};


export type MutationPublishBookArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String'];
};


export type MutationRemoveBanArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveBookArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveBookCommentArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveBookLikeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveBookModeratorArgs = {
  removeBookModeratorDto: RemoveBookModeratorDto;
};


export type MutationRemoveFragmentArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveFragmentCommentArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveFragmentLikeArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveNotificationArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationRemoveReadingListArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationResetPasswordArgs = {
  resetPasswordDto: ResetPasswordDto;
};


export type MutationSignupArgs = {
  signupDto: SignupDto;
};


export type MutationUpdateAvatarArgs = {
  attachment: Scalars['Upload'];
};


export type MutationUpdateBookArgs = {
  id?: Maybe<Scalars['ID']>;
  updateBookDto: UpdateBookDto;
};


export type MutationUpdateFragmentArgs = {
  id?: Maybe<Scalars['ID']>;
  updateFragmentDto: UpdateFragmentDto;
};


export type MutationUpdatePaymentMethodArgs = {
  updateStripePaymentMethodDto: UpdateStripePaymentMethodDto;
};


export type MutationUpdateReadingListArgs = {
  id?: Maybe<Scalars['ID']>;
  updateReadingListDto: UpdateReadingListDto;
};


export type MutationUpdateStripeSubscriptionArgs = {
  updateStripeSubscriptionDto: UpdateStripeSubscriptionDto;
};


export type MutationUpdateUserArgs = {
  updateUserDto: UpdateUserDto;
};


export type MutationVerifyAccountArgs = {
  verifyStripeAccountDto: VerifyStripeAccountDto;
};

export type Notification = {
  readonly __typename?: 'Notification';
  readonly book?: Maybe<Book>;
  readonly bookId?: Maybe<Scalars['ID']>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragment?: Maybe<Fragment>;
  readonly fragmentId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly isRead: Scalars['Boolean'];
  readonly owner: User;
  readonly ownerId: Scalars['ID'];
  readonly recipient: User;
  readonly recipientId: Scalars['ID'];
  readonly type: NotificationType;
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type NotificationEdge = {
  readonly __typename?: 'NotificationEdge';
  readonly cursor: Scalars['String'];
  readonly node: Notification;
};

export type NotificationPagination = {
  readonly __typename?: 'NotificationPagination';
  readonly edges?: Maybe<ReadonlyArray<NotificationEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

/** Notification types */
export enum NotificationType {
  BOOK_PUBLISHED = 'BOOK_PUBLISHED',
  COAUTHOR_INVITE = 'COAUTHOR_INVITE',
  FRAGMENT_APPROVED = 'FRAGMENT_APPROVED',
  FRAGMENT_DECLINED = 'FRAGMENT_DECLINED',
  MODERATOR_INVITE = 'MODERATOR_INVITE',
  NEW_COMMENT_BOOK = 'NEW_COMMENT_BOOK',
  NEW_COMMENT_FRAGMENT = 'NEW_COMMENT_FRAGMENT',
  NEW_FRAGMENT = 'NEW_FRAGMENT'
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc'
}

/** Properties by which entity connections can be ordered. */
export enum OrderField {
  CREATEDAT = 'createdAt',
  LIKES = 'likes',
  READS = 'reads'
}

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly endCursor?: Maybe<Scalars['String']>;
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor?: Maybe<Scalars['String']>;
};

export type PaginationArgs = {
  readonly after?: Maybe<Scalars['ID']>;
  readonly before?: Maybe<Scalars['ID']>;
  readonly first?: Maybe<Scalars['Int']>;
  readonly last?: Maybe<Scalars['Int']>;
};

export type PayoutDto = {
  readonly amount: Scalars['Float'];
};

export type PremiumAuthorPayment = {
  readonly __typename?: 'PremiumAuthorPayment';
  readonly amount: Scalars['Float'];
  readonly books: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type PremiumAuthorPaymentEdge = {
  readonly __typename?: 'PremiumAuthorPaymentEdge';
  readonly cursor: Scalars['String'];
  readonly node: PremiumAuthorPayment;
};

export type PremiumAuthorPaymentPagination = {
  readonly __typename?: 'PremiumAuthorPaymentPagination';
  readonly edges?: Maybe<ReadonlyArray<PremiumAuthorPaymentEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type PremiumUser = {
  readonly __typename?: 'PremiumUser';
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly customerId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly subscriptionId: Scalars['String'];
  readonly subscriptionInfo: SubscriptionInfo;
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['ID'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly adminFindBooks: BookPagination;
  readonly adminFindFeedback: FeedbackPagination;
  readonly adminFindReports: ReportPagination;
  readonly adminFindUser?: Maybe<User>;
  readonly adminFindUsers: UserPagination;
  readonly checkLogin?: Maybe<User>;
  readonly findBook?: Maybe<Book>;
  readonly findBookCoAuthor?: Maybe<BookCoAuthor>;
  readonly findBookCoAuthors: BookCoAuthorPagination;
  readonly findBookComments: BookCommentPagination;
  readonly findBookFragmentContributions: FragmentPagination;
  readonly findBookModerator?: Maybe<BookModerator>;
  readonly findBookModerators: BookModeratorPagination;
  readonly findBooks: BookPagination;
  readonly findCategories: CategoryPagination;
  readonly findChatMessages?: Maybe<ChatMessagePagination>;
  readonly findChats: ChatPagination;
  readonly findDraftBooks: BookPagination;
  readonly findDraftFragments: FragmentPagination;
  readonly findFragment?: Maybe<Fragment>;
  readonly findFragmentAlternatives?: Maybe<FragmentAlternativePagination>;
  readonly findFragmentComments: FragmentCommentPagination;
  readonly findFragments?: Maybe<FragmentPagination>;
  readonly findNotifications: NotificationPagination;
  readonly findPayments: PremiumAuthorPaymentPagination;
  readonly findReadingListBooks?: Maybe<BookPagination>;
  readonly findReadingLists?: Maybe<ReadingListPagination>;
  readonly findStripeConnectedAccount?: Maybe<StripeConnected>;
  readonly findStripeSubscription?: Maybe<PremiumUser>;
  readonly findSupportedCountries: ReadonlyArray<StripeCountry>;
  readonly findTags: TagPagination;
  readonly findUser?: Maybe<User>;
  readonly findUserFragmentContributions: FragmentContributionPagination;
  readonly findUsers: UserPagination;
  readonly getAllIdsForBookFragments?: Maybe<ReadonlyArray<FragmentMetadata>>;
  readonly getAllIdsForBooks?: Maybe<ReadonlyArray<Book>>;
  readonly getAllUsernamesForUsers?: Maybe<ReadonlyArray<User>>;
  readonly isBookLiked?: Maybe<BookLike>;
  readonly isBookRead?: Maybe<BookRead>;
  readonly isFragmentLiked?: Maybe<FragmentLike>;
  readonly mostPopularBooks?: Maybe<ReadonlyArray<Book>>;
  readonly mostPopularEditingBooks?: Maybe<ReadonlyArray<Book>>;
  readonly mostReadBooks?: Maybe<ReadonlyArray<Book>>;
  readonly recommendedBooks?: Maybe<ReadonlyArray<Book>>;
  readonly relatedBooks?: Maybe<ReadonlyArray<Book>>;
  readonly searchBooks: BookPagination;
};


export type QueryAdminFindBooksArgs = {
  pagination: PaginationArgs;
};


export type QueryAdminFindFeedbackArgs = {
  pagination: PaginationArgs;
};


export type QueryAdminFindReportsArgs = {
  pagination: PaginationArgs;
};


export type QueryAdminFindUserArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryAdminFindUsersArgs = {
  pagination: PaginationArgs;
};


export type QueryFindBookArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFindBookCoAuthorArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFindBookCoAuthorsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindBookCommentsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindBookFragmentContributionsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindBookModeratorArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFindBookModeratorsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindBooksArgs = {
  bookId?: Maybe<Scalars['ID']>;
  isFork?: Maybe<Scalars['Boolean']>;
  pagination: PaginationArgs;
  status?: Maybe<BookVisibleStatus>;
  userId?: Maybe<Scalars['ID']>;
};


export type QueryFindCategoriesArgs = {
  pagination: PaginationArgs;
};


export type QueryFindChatMessagesArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination?: Maybe<PaginationArgs>;
};


export type QueryFindChatsArgs = {
  pagination: PaginationArgs;
};


export type QueryFindDraftBooksArgs = {
  id?: Maybe<Scalars['ID']>;
  isFork?: Maybe<Scalars['Boolean']>;
  pagination: PaginationArgs;
};


export type QueryFindDraftFragmentsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindFragmentArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryFindFragmentAlternativesArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindFragmentCommentsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindFragmentsArgs = {
  bookId?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
  status?: Maybe<FragmentVisibleStatus>;
};


export type QueryFindNotificationsArgs = {
  pagination: PaginationArgs;
};


export type QueryFindPaymentsArgs = {
  pagination: PaginationArgs;
};


export type QueryFindReadingListBooksArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindReadingListsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindTagsArgs = {
  id?: Maybe<Scalars['ID']>;
  pagination: PaginationArgs;
};


export type QueryFindUserArgs = {
  username: Scalars['String'];
};


export type QueryFindUserFragmentContributionsArgs = {
  pagination: PaginationArgs;
};


export type QueryFindUsersArgs = {
  bookId?: Maybe<Scalars['ID']>;
  limit?: Maybe<Scalars['String']>;
  pagination: PaginationArgs;
};


export type QueryGetAllIdsForBookFragmentsArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryIsBookLikedArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryIsBookReadArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryIsFragmentLikedArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryRelatedBooksArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QuerySearchBooksArgs = {
  category?: Maybe<Scalars['ID']>;
  isMature?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Language>;
  orderBy?: Maybe<EntityOrder>;
  pagination: PaginationArgs;
  query?: Maybe<Scalars['String']>;
  status?: Maybe<BookVisibleStatus>;
};

export type ReadingList = {
  readonly __typename?: 'ReadingList';
  readonly books: ReadonlyArray<Book>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly isPublic: Scalars['Boolean'];
  readonly title: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type ReadingListEdge = {
  readonly __typename?: 'ReadingListEdge';
  readonly cursor: Scalars['String'];
  readonly node: ReadingList;
};

export type ReadingListPagination = {
  readonly __typename?: 'ReadingListPagination';
  readonly edges?: Maybe<ReadonlyArray<ReadingListEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type RemoveBookModeratorDto = {
  readonly bookId: Scalars['ID'];
  readonly userId: Scalars['ID'];
};

export type Report = {
  readonly __typename?: 'Report';
  readonly author: User;
  readonly authorId: Scalars['String'];
  readonly book?: Maybe<Book>;
  readonly bookComment?: Maybe<BookComment>;
  readonly bookCommentId?: Maybe<Scalars['String']>;
  readonly bookId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly fragment?: Maybe<Fragment>;
  readonly fragmentComment?: Maybe<FragmentComment>;
  readonly fragmentCommentId?: Maybe<Scalars['String']>;
  readonly fragmentId?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly motive: Scalars['String'];
  readonly origin: ReportOrigin;
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user?: Maybe<User>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type ReportEdge = {
  readonly __typename?: 'ReportEdge';
  readonly cursor: Scalars['String'];
  readonly node: Report;
};

/** Report origin types */
export enum ReportOrigin {
  BOOK = 'BOOK',
  BOOK_COMMENT = 'BOOK_COMMENT',
  FRAGMENT = 'FRAGMENT',
  FRAGMENT_COMMENT = 'FRAGMENT_COMMENT',
  USER = 'USER'
}

export type ReportPagination = {
  readonly __typename?: 'ReportPagination';
  readonly edges?: Maybe<ReadonlyArray<ReportEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type ResetPasswordDto = {
  readonly email: Scalars['String'];
};

export type SignupDto = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly password: Scalars['String'];
  readonly username: Scalars['String'];
};

export type StripeConnected = {
  readonly __typename?: 'StripeConnected';
  readonly accountId?: Maybe<Scalars['String']>;
  readonly bankId?: Maybe<Scalars['String']>;
  readonly bankInfo?: Maybe<BankInfo>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly money: Scalars['Float'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly user: User;
  readonly userId: Scalars['ID'];
  readonly verificationLink?: Maybe<Scalars['String']>;
  readonly verificationToken?: Maybe<Scalars['String']>;
  readonly verified: Scalars['Boolean'];
};

export type StripeCountry = {
  readonly __typename?: 'StripeCountry';
  readonly defaultCurrency: Scalars['String'];
  readonly id: Scalars['String'];
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly NEW_CHAT?: Maybe<Chat>;
  readonly NEW_CHAT_MESSAGE?: Maybe<ChatMessage>;
};

export type SubscriptionInfo = {
  readonly __typename?: 'SubscriptionInfo';
  readonly amountDue: Scalars['Int'];
  readonly last4: Scalars['String'];
  readonly nextPayment: Scalars['Date'];
  readonly type: Scalars['Int'];
};

export type Tag = {
  readonly __typename?: 'Tag';
  readonly category: Category;
  readonly categoryId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
};

export type TagEdge = {
  readonly __typename?: 'TagEdge';
  readonly cursor: Scalars['String'];
  readonly node: Tag;
};

export type TagPagination = {
  readonly __typename?: 'TagPagination';
  readonly edges?: Maybe<ReadonlyArray<TagEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type Token = {
  readonly __typename?: 'Token';
  readonly accessToken: Scalars['String'];
  /** JWT refresh token */
  readonly refreshToken: Scalars['String'];
};

export type UpdateBookDto = {
  readonly category?: Maybe<Scalars['ID']>;
  readonly cover?: Maybe<Scalars['Upload']>;
  readonly customTags?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly description?: Maybe<Scalars['String']>;
  readonly forkAllowed?: Maybe<Scalars['Boolean']>;
  readonly isPremium?: Maybe<Scalars['Boolean']>;
  readonly language?: Maybe<Language>;
  readonly mature?: Maybe<Scalars['Boolean']>;
  readonly status?: Maybe<BookStatus>;
  readonly tags?: Maybe<ReadonlyArray<Scalars['ID']>>;
  readonly title?: Maybe<Scalars['String']>;
  readonly withHelp?: Maybe<Scalars['Boolean']>;
};

export type UpdateFragmentDto = {
  readonly content?: Maybe<Scalars['JSONObject']>;
  readonly retouch?: Maybe<Scalars['JSONObject']>;
  readonly status: FragmentStatus;
};

export type UpdateReadingListDto = {
  readonly action?: Maybe<ListActions>;
  readonly book?: Maybe<Scalars['ID']>;
  readonly isPublic?: Maybe<Scalars['Boolean']>;
  readonly title?: Maybe<Scalars['String']>;
};

export type UpdateStripePaymentMethodDto = {
  readonly token: Scalars['String'];
};

export type UpdateStripeSubscriptionDto = {
  readonly period: Scalars['Int'];
};

export type UpdateUserDto = {
  readonly bio?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly username: Scalars['String'];
};

export type User = {
  readonly __typename?: 'User';
  readonly avatar?: Maybe<Scalars['String']>;
  readonly ban?: Maybe<Ban>;
  readonly banId?: Maybe<Scalars['String']>;
  readonly bio?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  readonly createdAt: Scalars['Date'];
  readonly email: Scalars['String'];
  readonly facebookId?: Maybe<Scalars['String']>;
  readonly firstName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly isDeleted: Scalars['Boolean'];
  readonly isPremiumAuthor: Scalars['Boolean'];
  readonly isPremiumUser: Scalars['Boolean'];
  readonly isPremiumUserUntil?: Maybe<Scalars['Date']>;
  readonly lastName: Scalars['String'];
  readonly password?: Maybe<Scalars['String']>;
  readonly role: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  readonly updatedAt: Scalars['Date'];
  readonly username: Scalars['String'];
};

export type UserEdge = {
  readonly __typename?: 'UserEdge';
  readonly cursor: Scalars['String'];
  readonly node: User;
};

export type UserPagination = {
  readonly __typename?: 'UserPagination';
  readonly edges?: Maybe<ReadonlyArray<UserEdge>>;
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int'];
};

export type VerifyStripeAccountDto = {
  readonly token: Scalars['String'];
};

export type BanDataFragment = { readonly __typename?: 'Ban', readonly id: string, readonly motive: string };

export type CreateBanMutationVariables = Exact<{
  createBanDto: CreateBanDto;
}>;


export type CreateBanMutation = { readonly __typename?: 'Mutation', readonly createBan: { readonly __typename?: 'Ban', readonly id: string, readonly motive: string } };

export type RemoveBanMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveBanMutation = { readonly __typename?: 'Mutation', readonly removeBan: boolean };

export type BookDataFragment = { readonly __typename?: 'Book', readonly id: string, readonly title: string, readonly updatedAt: Date, readonly createdAt: Date, readonly publishedAt?: Date | null | undefined, readonly mature: boolean, readonly withHelp: boolean, readonly isPremium: boolean, readonly forkAllowed: boolean, readonly description?: string | null | undefined, readonly cover?: string | null | undefined, readonly status: BookStatus, readonly isFork: boolean, readonly bookId?: string | null | undefined, readonly language: Language, readonly forks: number, readonly authorId: string, readonly metadata: { readonly __typename?: 'BookMetadata', readonly id: string, readonly comments?: number | null | undefined, readonly fragments?: number | null | undefined, readonly likes: number, readonly reads: number, readonly category: { readonly __typename?: 'Category', readonly id: string }, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string }>, readonly customTags?: ReadonlyArray<{ readonly __typename?: 'CustomTag', readonly id: string }> | null | undefined }, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } };

export type BookMetaDataFragment = { readonly __typename?: 'BookMetadata', readonly id: string, readonly comments?: number | null | undefined, readonly fragments?: number | null | undefined, readonly likes: number, readonly reads: number, readonly category: { readonly __typename?: 'Category', readonly id: string }, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string }>, readonly customTags?: ReadonlyArray<{ readonly __typename?: 'CustomTag', readonly id: string }> | null | undefined };

export type BooksQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type BooksQuery = { readonly __typename?: 'Query', readonly adminFindBooks: { readonly __typename?: 'BookPagination', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'BookEdge', readonly node: { readonly __typename?: 'Book', readonly id: string, readonly title: string, readonly updatedAt: Date, readonly createdAt: Date, readonly publishedAt?: Date | null | undefined, readonly mature: boolean, readonly withHelp: boolean, readonly isPremium: boolean, readonly forkAllowed: boolean, readonly description?: string | null | undefined, readonly cover?: string | null | undefined, readonly status: BookStatus, readonly isFork: boolean, readonly bookId?: string | null | undefined, readonly language: Language, readonly forks: number, readonly authorId: string, readonly metadata: { readonly __typename?: 'BookMetadata', readonly id: string, readonly comments?: number | null | undefined, readonly fragments?: number | null | undefined, readonly likes: number, readonly reads: number, readonly category: { readonly __typename?: 'Category', readonly id: string }, readonly tags: ReadonlyArray<{ readonly __typename?: 'Tag', readonly id: string }>, readonly customTags?: ReadonlyArray<{ readonly __typename?: 'CustomTag', readonly id: string }> | null | undefined }, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } } }> | null | undefined, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null | undefined, readonly endCursor?: string | null | undefined } } };

export type DeleteBookMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBookMutation = { readonly __typename?: 'Mutation', readonly adminRemoveBook: { readonly __typename?: 'Book', readonly id: string, readonly title: string } };

export type FeedbackDataFragment = { readonly __typename?: 'Feedback', readonly id: string, readonly content: string, readonly email?: string | null | undefined, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } | null | undefined };

export type FindFeedbackQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type FindFeedbackQuery = { readonly __typename?: 'Query', readonly adminFindFeedback: { readonly __typename?: 'FeedbackPagination', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'FeedbackEdge', readonly node: { readonly __typename?: 'Feedback', readonly id: string, readonly content: string, readonly email?: string | null | undefined, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } | null | undefined } }> | null | undefined, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null | undefined, readonly endCursor?: string | null | undefined } } };

export type PageInfoDataFragment = { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null | undefined, readonly endCursor?: string | null | undefined };

export type AuthorFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string };

export type ReportDataFragment = { readonly __typename?: 'Report', readonly id: string, readonly motive: string, readonly origin: ReportOrigin, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string }, readonly book?: { readonly __typename?: 'Book', readonly id: string, readonly title: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly fragment?: { readonly __typename?: 'Fragment', readonly id: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } | null | undefined } | null | undefined, readonly fragmentComment?: { readonly __typename?: 'FragmentComment', readonly id: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly bookComment?: { readonly __typename?: 'BookComment', readonly id: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } | null | undefined };

export type FindReportsQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type FindReportsQuery = { readonly __typename?: 'Query', readonly adminFindReports: { readonly __typename?: 'ReportPagination', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'ReportEdge', readonly node: { readonly __typename?: 'Report', readonly id: string, readonly motive: string, readonly origin: ReportOrigin, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string }, readonly book?: { readonly __typename?: 'Book', readonly id: string, readonly title: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly fragment?: { readonly __typename?: 'Fragment', readonly id: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } | null | undefined } | null | undefined, readonly fragmentComment?: { readonly __typename?: 'FragmentComment', readonly id: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly bookComment?: { readonly __typename?: 'BookComment', readonly id: string, readonly author: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } } | null | undefined, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string } | null | undefined } }> | null | undefined, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null | undefined, readonly endCursor?: string | null | undefined } } };

export type UserDataFragment = { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string };

export type LoginMutationVariables = Exact<{
  loginDto: LoginDto;
}>;


export type LoginMutation = { readonly __typename?: 'Mutation', readonly adminLogin: { readonly __typename?: 'Auth', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } | null | undefined } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { readonly __typename?: 'Mutation', readonly adminLogout: boolean };

export type CheckLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckLoginQuery = { readonly __typename?: 'Query', readonly checkLogin?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } | null | undefined };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { readonly __typename?: 'Query', readonly adminFindUser?: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string, readonly ban?: { readonly __typename?: 'Ban', readonly id: string, readonly motive: string } | null | undefined } | null | undefined };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  adminUpdateUserDto: AdminUpdateUserDto;
}>;


export type UpdateUserMutation = { readonly __typename?: 'Mutation', readonly adminUpdateUser: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } };

export type UsersQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type UsersQuery = { readonly __typename?: 'Query', readonly adminFindUsers: { readonly __typename?: 'UserPagination', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node: { readonly __typename?: 'User', readonly id: string, readonly firstName: string, readonly lastName: string, readonly username: string, readonly bio?: string | null | undefined, readonly email: string, readonly facebookId?: string | null | undefined, readonly isPremiumAuthor: boolean, readonly isPremiumUser: boolean, readonly avatar?: string | null | undefined, readonly isDeleted: boolean, readonly createdAt: Date, readonly updatedAt: Date, readonly role: string } }> | null | undefined, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor?: string | null | undefined, readonly endCursor?: string | null | undefined } } };

export const BanDataFragmentDoc = gql`
    fragment BanData on Ban {
  id
  motive
}
    `;
export const BookMetaDataFragmentDoc = gql`
    fragment BookMetaData on BookMetadata {
  id
  category {
    id
  }
  tags {
    id
  }
  customTags {
    id
  }
  comments
  fragments
  likes
  reads
}
    `;
export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  id
  firstName
  lastName
  username
  bio
  email
  facebookId
  isPremiumAuthor
  isPremiumUser
  avatar
  isDeleted
  createdAt
  updatedAt
  role
}
    `;
export const BookDataFragmentDoc = gql`
    fragment BookData on Book {
  id
  title
  updatedAt
  createdAt
  publishedAt
  mature
  withHelp
  isPremium
  forkAllowed
  description
  cover
  status
  isFork
  bookId
  language
  forks
  authorId
  metadata {
    ...BookMetaData
  }
  author {
    ...UserData
  }
}
    ${BookMetaDataFragmentDoc}
${UserDataFragmentDoc}`;
export const FeedbackDataFragmentDoc = gql`
    fragment FeedbackData on Feedback {
  id
  content
  email
  user {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export const PageInfoDataFragmentDoc = gql`
    fragment PageInfoData on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const AuthorFragmentDoc = gql`
    fragment Author on User {
  id
  firstName
  lastName
}
    `;
export const ReportDataFragmentDoc = gql`
    fragment ReportData on Report {
  id
  motive
  author {
    ...UserData
  }
  origin
  book {
    id
    title
    author {
      ...Author
    }
  }
  fragment {
    id
    author {
      ...Author
    }
  }
  fragmentComment {
    id
    author {
      ...Author
    }
  }
  bookComment {
    id
    author {
      ...Author
    }
  }
  user {
    id
    firstName
    lastName
  }
}
    ${UserDataFragmentDoc}
${AuthorFragmentDoc}`;
export const CreateBanDocument = gql`
    mutation CreateBan($createBanDto: CreateBanDto!) {
  createBan(createBanDto: $createBanDto) {
    ...BanData
  }
}
    ${BanDataFragmentDoc}`;
export type CreateBanMutationFn = Apollo.MutationFunction<CreateBanMutation, CreateBanMutationVariables>;

/**
 * __useCreateBanMutation__
 *
 * To run a mutation, you first call `useCreateBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBanMutation, { data, loading, error }] = useCreateBanMutation({
 *   variables: {
 *      createBanDto: // value for 'createBanDto'
 *   },
 * });
 */
export function useCreateBanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBanMutation, CreateBanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBanMutation, CreateBanMutationVariables>(CreateBanDocument, options);
      }
export type CreateBanMutationHookResult = ReturnType<typeof useCreateBanMutation>;
export type CreateBanMutationResult = Apollo.MutationResult<CreateBanMutation>;
export type CreateBanMutationOptions = Apollo.BaseMutationOptions<CreateBanMutation, CreateBanMutationVariables>;
export const RemoveBanDocument = gql`
    mutation RemoveBan($id: ID!) {
  removeBan(id: $id)
}
    `;
export type RemoveBanMutationFn = Apollo.MutationFunction<RemoveBanMutation, RemoveBanMutationVariables>;

/**
 * __useRemoveBanMutation__
 *
 * To run a mutation, you first call `useRemoveBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBanMutation, { data, loading, error }] = useRemoveBanMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBanMutation, RemoveBanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveBanMutation, RemoveBanMutationVariables>(RemoveBanDocument, options);
      }
export type RemoveBanMutationHookResult = ReturnType<typeof useRemoveBanMutation>;
export type RemoveBanMutationResult = Apollo.MutationResult<RemoveBanMutation>;
export type RemoveBanMutationOptions = Apollo.BaseMutationOptions<RemoveBanMutation, RemoveBanMutationVariables>;
export const BooksDocument = gql`
    query Books($pagination: PaginationArgs!) {
  adminFindBooks(pagination: $pagination) {
    totalCount
    edges {
      node {
        ...BookData
      }
    }
    pageInfo {
      ...PageInfoData
    }
  }
}
    ${BookDataFragmentDoc}
${PageInfoDataFragmentDoc}`;

/**
 * __useBooksQuery__
 *
 * To run a query within a React component, call `useBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBooksQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useBooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BooksQuery, BooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BooksQuery, BooksQueryVariables>(BooksDocument, options);
      }
export function useBooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BooksQuery, BooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BooksQuery, BooksQueryVariables>(BooksDocument, options);
        }
export type BooksQueryHookResult = ReturnType<typeof useBooksQuery>;
export type BooksLazyQueryHookResult = ReturnType<typeof useBooksLazyQuery>;
export type BooksQueryResult = Apollo.QueryResult<BooksQuery, BooksQueryVariables>;
export const DeleteBookDocument = gql`
    mutation DeleteBook($id: ID!) {
  adminRemoveBook(id: $id) {
    id
    title
  }
}
    `;
export type DeleteBookMutationFn = Apollo.MutationFunction<DeleteBookMutation, DeleteBookMutationVariables>;

/**
 * __useDeleteBookMutation__
 *
 * To run a mutation, you first call `useDeleteBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookMutation, { data, loading, error }] = useDeleteBookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBookMutation, DeleteBookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBookMutation, DeleteBookMutationVariables>(DeleteBookDocument, options);
      }
export type DeleteBookMutationHookResult = ReturnType<typeof useDeleteBookMutation>;
export type DeleteBookMutationResult = Apollo.MutationResult<DeleteBookMutation>;
export type DeleteBookMutationOptions = Apollo.BaseMutationOptions<DeleteBookMutation, DeleteBookMutationVariables>;
export const FindFeedbackDocument = gql`
    query FindFeedback($pagination: PaginationArgs!) {
  adminFindFeedback(pagination: $pagination) {
    totalCount
    edges {
      node {
        ...FeedbackData
      }
    }
    pageInfo {
      ...PageInfoData
    }
  }
}
    ${FeedbackDataFragmentDoc}
${PageInfoDataFragmentDoc}`;

/**
 * __useFindFeedbackQuery__
 *
 * To run a query within a React component, call `useFindFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFeedbackQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFindFeedbackQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindFeedbackQuery, FindFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindFeedbackQuery, FindFeedbackQueryVariables>(FindFeedbackDocument, options);
      }
export function useFindFeedbackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindFeedbackQuery, FindFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindFeedbackQuery, FindFeedbackQueryVariables>(FindFeedbackDocument, options);
        }
export type FindFeedbackQueryHookResult = ReturnType<typeof useFindFeedbackQuery>;
export type FindFeedbackLazyQueryHookResult = ReturnType<typeof useFindFeedbackLazyQuery>;
export type FindFeedbackQueryResult = Apollo.QueryResult<FindFeedbackQuery, FindFeedbackQueryVariables>;
export const FindReportsDocument = gql`
    query FindReports($pagination: PaginationArgs!) {
  adminFindReports(pagination: $pagination) {
    totalCount
    edges {
      node {
        ...ReportData
      }
    }
    pageInfo {
      ...PageInfoData
    }
  }
}
    ${ReportDataFragmentDoc}
${PageInfoDataFragmentDoc}`;

/**
 * __useFindReportsQuery__
 *
 * To run a query within a React component, call `useFindReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindReportsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFindReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindReportsQuery, FindReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindReportsQuery, FindReportsQueryVariables>(FindReportsDocument, options);
      }
export function useFindReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindReportsQuery, FindReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindReportsQuery, FindReportsQueryVariables>(FindReportsDocument, options);
        }
export type FindReportsQueryHookResult = ReturnType<typeof useFindReportsQuery>;
export type FindReportsLazyQueryHookResult = ReturnType<typeof useFindReportsLazyQuery>;
export type FindReportsQueryResult = Apollo.QueryResult<FindReportsQuery, FindReportsQueryVariables>;
export const LoginDocument = gql`
    mutation Login($loginDto: LoginDto!) {
  adminLogin(loginDto: $loginDto) {
    user {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      loginDto: // value for 'loginDto'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  adminLogout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const CheckLoginDocument = gql`
    query CheckLogin {
  checkLogin {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;

/**
 * __useCheckLoginQuery__
 *
 * To run a query within a React component, call `useCheckLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckLoginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckLoginQuery, CheckLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckLoginQuery, CheckLoginQueryVariables>(CheckLoginDocument, options);
      }
export function useCheckLoginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckLoginQuery, CheckLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckLoginQuery, CheckLoginQueryVariables>(CheckLoginDocument, options);
        }
export type CheckLoginQueryHookResult = ReturnType<typeof useCheckLoginQuery>;
export type CheckLoginLazyQueryHookResult = ReturnType<typeof useCheckLoginLazyQuery>;
export type CheckLoginQueryResult = Apollo.QueryResult<CheckLoginQuery, CheckLoginQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  adminFindUser(id: $id) {
    ...UserData
    ban {
      id
      motive
    }
  }
}
    ${UserDataFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $adminUpdateUserDto: AdminUpdateUserDto!) {
  adminUpdateUser(id: $id, adminUpdateUserDto: $adminUpdateUserDto) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adminUpdateUserDto: // value for 'adminUpdateUserDto'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UsersDocument = gql`
    query Users($pagination: PaginationArgs!) {
  adminFindUsers(pagination: $pagination) {
    totalCount
    edges {
      node {
        ...UserData
      }
    }
    pageInfo {
      ...PageInfoData
    }
  }
}
    ${UserDataFragmentDoc}
${PageInfoDataFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;